import { Component } from 'react';

class Column extends Component {}

export default Column;
